module.exports = __webpack_public_path__ + "img/china.c31a2bce.svg";